import React, { useState, useEffect } from 'react'
import Dropdown from 'react-dropdown';
import 'react-dropdown/style.css';
import axios from 'axios';
export default function D_Bank() {
    const [value, setVal] = useState(0)
    const India = () => {
        return <table>
            <tr>
                <td>
                    <label class="input">
                        <input id='Name' autocomplete="off" name='name' class="input__field" type="text" placeholder=" " />
                        <span class="input__label">Name </span>
                    </label>
                </td>
                <td>
                    <label class="input">
                        <input id='ifsc' autocomplete="off" name='number' class="input__field" type="text" placeholder=" " />
                        <span class="input__label">IFSC Number </span>
                    </label>
                </td>
            </tr>
            <tr>
                <td>
                    <label class="input">
                        <input id='Account_number' autocomplete="off" name='number' class="input__field" type="text" placeholder=" " />
                        <span class="input__label">A/C Number </span>
                    </label>
                </td>
                <td>
                    <label class="input">
                        <input id='Bank_address' autocomplete="off" name='address' class="input__field" type="text" placeholder=" " />
                        <span class="input__label">Bank Address </span>
                    </label>
                </td>
            </tr>
            <tr>
                <td></td>
                <td className='all'>
                    <button onClick={() => submit('IND')}>Submit</button>
                </td>
            </tr>
        </table>
    }
    const Aus = () => {
        return <table>
            <tr>
                <td>
                    <label class="input">
                        <input id='Name' autocomplete="off" class="input__field" type="text" placeholder=" " />
                        <span class="input__label">Name </span>
                    </label>
                </td>
                <td>
                    <label class="input">
                        <input id='bank_swift' autocomplete="off" class="input__field" type="text" placeholder=" " />
                        <span class="input__label">Bank's SWIFT code </span>
                    </label>
                </td>
            </tr>
            <tr>
                <td>
                    <label class="input">
                        <input id='Address' autocomplete="off" class="input__field" type="text" placeholder=" " />
                        <span class="input__label">Address</span>
                    </label>
                </td>
                <td>
                    <label class="input">
                        <input id='bank_sort' autocomplete="off" class="input__field" type="text" placeholder=" " />
                        <span class="input__label">Bank's Sort code</span>
                    </label>
                </td>
            </tr>
            <tr>
                <td>
                    <label class="input">
                        <input id='Bank_name' autocomplete="off" class="input__field" type="text" placeholder=" " />
                        <span class="input__label">Bank name</span>
                    </label>
                </td>
                <td>
                    <label class="input">
                        <input id='Bank_address' autocomplete="off" class="input__field" type="text" placeholder=" " />
                        <span class="input__label">Bank Address</span>
                    </label>
                </td>
            </tr>
            <tr>
                <td>
                    <label class="input">
                        <input id='Account_number' autocomplete="off" class="input__field" type="text" placeholder=" " />
                        <span class="input__label">A/C number</span>
                    </label>
                </td>
                <td>
                    <label class="input">
                        <input id='bank_iban' autocomplete="off" class="input__field" type="text" placeholder=" " />
                        <span class="input__label">Bank's IBAN</span>
                    </label>
                </td>
            </tr>
            <tr>
                <td>
                    <label class="input">
                        <input id='bank_bsb' autocomplete="off" class="input__field" type="text" placeholder=" " />
                        <span class="input__label">Bank's BSB</span>
                    </label>
                </td>
            </tr>
            <tr>
                <td></td>
                <td className='all'>
                    <button onClick={() => submit('AUS')}>Submit</button>
                </td>
            </tr>
        </table>
    }
    const Eur = () => {
        return <table>
            <tr>
                <td>
                    <label class="input">
                        <input id='Name' autocomplete="off" class="input__field" type="text" placeholder=" " />
                        <span class="input__label">Name </span>
                    </label>
                </td>
                <td>
                    <label class="input">
                        <input id='bank_swift' autocomplete="off" class="input__field" type="text" placeholder=" " />
                        <span class="input__label">Bank's SWIFT code </span>
                    </label>
                </td>
            </tr>
            <tr>
                <td>
                    <label class="input">
                        <input id='Address' autocomplete="off" class="input__field" type="text" placeholder=" " />
                        <span class="input__label">Address</span>
                    </label>
                </td>
                <td>
                    <label class="input">
                        <input id='bank_sort' autocomplete="off" class="input__field" type="text" placeholder=" " />
                        <span class="input__label">Bank's Sort code</span>
                    </label>
                </td>
            </tr>
            <tr>
                <td>
                    <label class="input">
                        <input id='Bank_name' autocomplete="off" class="input__field" type="text" placeholder=" " />
                        <span class="input__label">Bank name</span>
                    </label>
                </td>
                <td>
                    <label class="input">
                        <input id='Bank_address' autocomplete="off" class="input__field" type="text" placeholder=" " />
                        <span class="input__label">Bank Address</span>
                    </label>
                </td>
            </tr>
            <tr>
                <td>
                    <label class="input">
                        <input id='Account_number' autocomplete="off" class="input__field" type="text" placeholder=" " />
                        <span class="input__label">A/C number</span>
                    </label>
                </td>
                <td>
                    <label class="input">
                        <input id='bank_iban' autocomplete="off" class="input__field" type="text" placeholder=" " />
                        <span class="input__label">Bank's IBAN</span>
                    </label>
                </td>
            </tr>
            <tr>
                <td></td>
                <td className='all'>
                    <button onClick={() => submit('EUR')}>Submit</button>
                </td>
            </tr>
        </table>
    }
    const Oth = () => {
        let countries = ["Afghanistan", "Albania", "Algeria", "Andorra", "Angola", "Antigua and Barbuda", "Argentina", "Armenia",
            "Australia", "Austria", "Azerbaijan", "Bahamas", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium",
            "Belize", "Benin", "Bhutan", "Bolivia", "Bosnia and Herzegovina", "Botswana", "Brazil", "Brunei", "Bulgaria",
            "Burkina Faso", "Burundi", "Cambodia", "Cameroon", "Canada", "Cape Verde", "Central African Republic", "Chad",
            "Chile", "China", "Colombi", "Comoros", "Congo (Brazzaville)", "Congo", "Costa Rica", "Cote d'Ivoire", "Croatia",
            "Cuba", "Cyprus", "Czech Republic", "Denmark", "Djibouti", "Dominica", "Dominican Republic", "East Timor (Timor Timur)",
            "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Ethiopia", "Fiji", "Finland", "France",
            "Gabon", "Gambia, The", "Georgia", "Germany", "Ghana", "Greece", "Grenada", "Guatemala", "Guinea", "Guinea-Bissau",
            "Guyana", "Haiti", "Honduras", "Hungary", "Iceland", "Indonesia", "Iran", "Iraq", "Ireland", "Israel",
            "Italy", "Jamaica", "Japan", "Jordan", "Kazakhstan", "Kenya", "Kiribati", "Korea, North", "Korea, South", "Kuwait",
            "Kyrgyzstan", "Laos", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya", "Liechtenstein", "Lithuania", "Luxembourg",
            "Macedonia", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Marshall Islands", "Mauritania",
            "Mauritius", "Mexico", "Micronesia", "Moldova", "Monaco", "Mongolia", "Morocco", "Mozambique", "Myanmar", "Namibia",
            "Nauru", "Nepa", "Netherlands", "New Zealand", "Nicaragua", "Niger", "Nigeria", "Norway", "Oman", "Pakistan", "Palau",
            "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines", "Poland", "Portugal", "Qatar", "Romania", "Russia",
            "Rwanda", "Saint Kitts and Nevis", "Saint Lucia", "Saint Vincent", "Samoa", "San Marino", "Sao Tome and Principe",
            "Saudi Arabia", "Senegal", "Serbia and Montenegro", "Seychelles", "Sierra Leone", "Singapore", "Slovakia", "Slovenia",
            "Solomon Islands", "Somalia", "South Africa", "Spain", "Sri Lanka", "Sudan", "Suriname", "Swaziland", "Sweden",
            "Switzerland", "Syria", "Taiwan", "Tajikistan", "Tanzania", "Thailand", "Togo", "Tonga", "Trinidad and Tobago",
            "Tunisia", "Turkey", "Turkmenistan", "Tuvalu", "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom",
            "United States", "Uruguay", "Uzbekistan", "Vanuatu", "Vatican City", "Venezuela", "Vietnam", "Yemen", "Zambia", "Zimbabwe"]
        return <table>
            <tr>
                <td>
                    <label class="input">
                        <input id='Name' autocomplete="off" name='name' class="input__field" type="text" placeholder=" " />
                        <span class="input__label">Name </span>
                    </label>
                </td>
                <td>
                    <label class="input">
                        <input id='Bank_name' autocomplete="off" name='number' class="input__field" type="text" placeholder=" " />
                        <span class="input__label">Bank Name</span>
                    </label>
                </td>
            </tr>
            <tr>
                <td>
                    <label class="input">
                        <input id='Address' autocomplete="off" name='number' class="input__field" type="text" placeholder=" " />
                        <span class="input__label">Address</span>
                    </label>
                </td>
                <td>
                    <label class="input">
                        <input id='Account_number' autocomplete="off" name='address' class="input__field" type="text" placeholder=" " />
                        <span class="input__label">A/C Number</span>
                    </label>
                </td>
            </tr>
            <tr>
                <td className='BDCalign'>
                    Country : &ensp;<select className='CSel' id='country' >
                        <option value='India'> India </option>
                        {
                            Object.keys(countries).map((item) => (
                                <option value={countries[item]}> {countries[item]} </option>
                            ))
                        }
                    </select>
                    {/* <label class="input">
                        <input id='country' autocomplete="off" name='number' class="input__field" type="text" placeholder=" " />
                        <span class="input__label">Country</span>
                    </label> */}
                </td>
                <td>
                    <label class="input">
                        <input id='Bank_address' autocomplete="off" name='address' class="input__field" type="text" placeholder=" " />
                        <span class="input__label">Bank Address</span>
                    </label>
                </td>
            </tr>
            <tr>
                <td></td>
                <td className='all'>
                    <button onClick={() => submit('OTHERS')}>Submit</button>
                </td>
            </tr>
        </table>
    }
    const [selected, setSelected] = useState('')
    function showHide(e) {
        console.log(e)
        setSelected(e);
        switch (e) {
            case 'IND': setVal(1); break;
            case 'AUS': setVal(2); break;
            case 'EUR': setVal(3); break;
            case 'OTHERS': setVal(4); break;
            case 'none': setVal(0); break;
            default: setVal(0)
        }
    }
    function Show() {
        if (value == 1) return India()
        else if (value == 2) return Aus()
        else if (value == 3) return Eur()
        else if (value == 4) return Oth()
        else if (value == 0) return <><table className='banktab'>
            {data.region != '' ? <Dat /> : <><h2>Details not updated, Please fill up</h2></>}
        </table>
        </>
        else return <></>
    }
    const Dat = () => {
        var rows = []
        for (const property in data)
            if (data[property] && property != 'id' && property != 'user') rows.push(<tr><td>{property} : </td><td>{data[property]}</td></tr>)
        console.log(rows)
        return <>{rows}</>
    }
    const [data, setData] = useState({
        region: '',
        Name: '',
        Address: '',
        country: '',
        Bank_name: '',
        Account_number: '',
        ifsc: '',
        Bank_address: '',
        bank_swift: '',
        bank_iban: '',
        bank_sort: '',
        bank_bsb: '',
    })
    async function submit(cont) {
        var formData = new FormData();
        switch (cont) {
            case 'IND':
                formData.append('Name', document.getElementById('Name').value);
                formData.append('Account_number', document.getElementById('Account_number').value);
                formData.append('ifsc', document.getElementById('ifsc').value);
                formData.append('Bank_address', document.getElementById('Bank_address').value);
                formData.append('region', selected); break;
            case 'AUS':
                formData.append('Name', document.getElementById('Name').value);
                formData.append('Address', document.getElementById('Address').value);
                formData.append('country', selected);
                formData.append('Bank_name', document.getElementById('Bank_name').value);
                formData.append('Account_number', document.getElementById('Account_number').value);
                formData.append('Bank_address', document.getElementById('Bank_address').value);
                formData.append('bank_swift', document.getElementById('bank_swift').value);
                formData.append('bank_iban', document.getElementById('bank_iban').value);
                formData.append('bank_sort', document.getElementById('bank_sort').value);
                formData.append('bank_bsb', document.getElementById('bank_bsb').value);
                formData.append('region', selected); break;
            case 'EUR':
                formData.append('Name', document.getElementById('Name').value);
                formData.append('Address', document.getElementById('Address').value);
                formData.append('Bank_name', document.getElementById('Bank_name').value);
                formData.append('Account_number', document.getElementById('Account_number').value);
                formData.append('Bank_address', document.getElementById('Bank_address').value);
                formData.append('bank_swift', document.getElementById('bank_swift').value);
                formData.append('bank_iban', document.getElementById('bank_iban').value);
                formData.append('bank_sort', document.getElementById('bank_sort').value);
                formData.append('country', selected);
                formData.append('region', selected); break;
            case 'OTHERS':
                formData.append('Name', document.getElementById('Name').value);
                formData.append('Address', document.getElementById('Address').value);
                formData.append('Bank_name', document.getElementById('Bank_name').value);
                formData.append('country', document.getElementById('country').value);
                formData.append('Account_number', document.getElementById('Account_number').value);
                formData.append('Bank_address', document.getElementById('Bank_address').value);
                formData.append('region', selected); break;
        }
        let notify = document.getElementsByClassName('noti')[0];
        await axios({
            method: "post",
            url: `${process.env.REACT_APP_API_URL1}/consultant/bank_detailes/`,
            data: formData,
            headers: {
                "Content-Type": "multipart/form-data",
                'Authorization': `JWT ${localStorage.getItem('access')}`,
                'Accept': 'application/json'
            },
        }).then(async response => {
            console.log(response)
            setC(false)
            setVal(0)
            notify.innerHTML += `<div style="background-color:#d4edda;color:#155724" class='notifyUser'>
                            ${response.data.message}
                        </div>`;
            await axios.get(`${process.env.REACT_APP_API_URL1}/consultant/bank_detailes/`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `JWT ${localStorage.getItem('access')}`,
                    'Accept': 'application/json'
                }
            })
                .then(response => {
                    setData(response.data)
                    setTimeout(() => {
                        notify.removeChild(notify.lastChild)
                    }, 3000);
                }).catch(err => {
                    console.log(err)
                })
        }).catch(err => {
            console.log(err)
            notify.innerHTML += `<div style="background-color:#f8d7da;color:#721c24" class='notifyUser'>
                            ${err.response.data.message}
                        </div>`;
            setTimeout(() => {
                notify.removeChild(notify.lastChild)
            }, 3000);
            console.log(formData)
        })
    }
    const [click, setC] = useState(false)
    const options = [
        { value: 'Back', label: 'none' },
        { value: 'INDIA', label: 'IND' },
        { value: 'AUSTRALIA', label: 'AUS' },
        { value: 'EUROPEAN', label: 'EUR' },
        { value: 'OTHER COUNTRIES', label: 'OTHERS' },
    ];
    const [defaultOption, setDef] = useState({ value: 'Back', label: 'none' });
    const getData = async () => {
        await axios.get(`${process.env.REACT_APP_API_URL1}/consultant/bank_detailes/`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `JWT ${localStorage.getItem('access')}`,
                'Accept': 'application/json'
            }
        })
            .then(response => {
                setData(response.data)
            }).catch(err => {
                console.log(err)
                let notify = document.getElementsByClassName('noti')[0];
                // notify.innerHTML += `<div style="background-color:#f8d7da;color:#721c24" class='notifyUser'>
                //                 ${err.response.data.message}
                //             </div>`;
                setTimeout(() => {
                    notify.removeChild(notify.lastChild)
                }, 3000);
            })
    }
    useEffect(async () => {
        await getData();
    }, [])
    return (
        <div>

            {click ? <div className='detailsdiv'>
                <span>Country - </span>
                <Dropdown options={options}
                    className='select' controlClassName='myControlClassName'
                    onChange={(e) => { showHide(e.label); setDef(e) }}
                    value={defaultOption} placeholder="Select an option" />
                {/* <select onChange={(e) => { showHide(e) }}>
                    <option value="none" selected>Back</option>
                    <option value="ind">INDIA</option>
                    <option value="aus">AUSTRALIA</option>
                    <option value="euro">EUROPEAN</option>
                    <option value="other">OTHER COUNTRIES</option>
                </select> */}
            </div> : <></>}
            <div className='DetBank all'>
                <Show />
                {value == 0 ? <button onClick={() => { setC(true); setVal(6) }} className='end'>{data.Name == '' ? 'Fill Bank Details' : 'Edit'} </button> : <></>}
            </div>
        </div>
    )
}
